import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import FOperationCategoryFilter from '@/components/FOperationCategoryFilter';
import * as AHooks from 'ahooks';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import { PolicyFullInfo_Type } from '@/type/contractTypes';
import moment from 'moment';
import { DiscoverPageModelState, OnClickLoadMoreBtnAction } from '@/models/discoverPage';
import FResourceCard from '@/components/FResourceCard';
import FNoDataTip from '@/components/FNoDataTip';
import FListFooter, { listStateAndListMore } from '@/components/FListFooter';
import FLoading from '@/components/FIcons/FLoading';
import FLoadingTip from '@/components/FLoadingTip';

interface ResourceProps {
  search: string;
}

type ListType = {
  id: string;
  cover: string;
  name: string;
  title: string;
  version: string;
  policy: string[];
  type: string[];
  status: 0 | 1 | 2 | 4;
  authProblem?: boolean;
  updateDate: string;
  username: string;
  useAvatar: string;
  isChoice: boolean;
  collection?: {
    status: 'finish' | 'unFinish';
    count: number;
  } | null;
}[]

function Resource({ search }: ResourceProps) {

  const [$search, set$search, get$search] = FUtil.Hook.useGetState<string>('');
  const [$selectedOperationCategoryIDs, set$selectedOperationCategoryIDs, get$selectedOperationCategoryIDs] = FUtil.Hook.useGetState<string[]>(['#all']);
  const [$dataSource, set$dataSource, get$dataSource] = FUtil.Hook.useGetState<ListType>([]);
  const [$totalItem, set$totalItem, get$totalItem] = FUtil.Hook.useGetState<number>(-1);
  const [$state, set$state, get$state] = FUtil.Hook.useGetState<'loading' | 'noData' | 'noSearchResult' | 'loaded'>('loading');
  const [$more, set$more, get$more] = FUtil.Hook.useGetState<'loading' | 'andMore' | 'noMore'>('loading');

  AHooks.useDebounceEffect(() => {
    handle(true);
  }, [search], {
    wait: 300,
  });

  async function handle(restart: boolean = false) {

    let oldList: ListType = [];

    if (!restart) {
      oldList = get$dataSource();
      set$more('loading');
    } else {
      set$state('loading');
    }

    const selectedOperationCategoryIDs: string[] = get$selectedOperationCategoryIDs().filter((c) => {
      return c !== '#all';
    });

    const params: Parameters<typeof FServiceAPI.Resource.list>[0] = {
      skip: oldList.length,
      limit: FUtil.Predefined.pageSize,
      // startResourceId: dataSource[0]?.id,
      keywords: search,
      // resourceType: discoverPage.resourceType === '-1' ? undefined : discoverPage.resourceType,
      status: 1,
      operationCategoryCode: selectedOperationCategoryIDs[selectedOperationCategoryIDs.length - 1],
      // operationCategoryCode: selectedOperationCategoryIDs.at(-1),
      // @ts-ignore
      // operationTypes: discoverPage.filterSelected,
    };

    const { data: data_resources }: {
      data: {
        dataList: {
          resourceId: string;
          coverImages: string[];
          resourceName: string;
          resourceTitle: string;
          resourceType: string[];
          updateDate: string;
          status: 0 | 1 | 2 | 4;
          latestVersion: string;
          policies: PolicyFullInfo_Type[];
          // updateDate: string;
          username: string;
          userId: number;
          operationType: 0 | 1 | 2 | 3 | 4 | 5;
          serializeStatus: 0 | 1;
          subjectType: 1 | 4;
          resourceVersions: {
            versionId: string;
          }[];
        }[];
        totalItem: number;
      };
    } = await FServiceAPI.Resource.list(params);

    const params2: Parameters<typeof FServiceAPI.Resource.getVersionList>[0] = {
      versionIds: data_resources.dataList.filter((bi) => {
        return bi.subjectType === 4;
      }).map((bi) => {
        return bi.resourceVersions[0].versionId;
      }).join(','),
    };
    const { data: data_versionList }: {
      data: {
        resourceId: string;
        catalogueProperty: { collection_item_count: number };
      }[];
    } = await FServiceAPI.Resource.getVersionList(params2);

    const list: ListType = [
      ...oldList,
      ...data_resources.dataList
        // .filter((i) => {
        //   return !existentResourceIDs.includes(i.resourceId);
        // })
        .map<DiscoverPageModelState['dataSource'][number]>((i) => {
          // console.log(i, 'i#@@#$@#$@#$@#$@#4234098ijosfdlksd');
          const resourceVersionInfo = data_versionList.find((vl) => {
            return vl.resourceId === i.resourceId;
          });
          return {
            id: i.resourceId,
            cover: i.coverImages.length > 0 ? i.coverImages[0] : '',
            name: i.resourceName,
            title: i.resourceTitle,
            version: i.latestVersion,
            policy: i.policies
              .filter((l) => {
                return l.status === 1;
              })
              .map((l) => l.policyName),
            type: i.resourceType,
            status: 1,
            updateDate: moment(i.updateDate).format('YYYY-MM-DD'),
            username: i.username,
            useAvatar: `https://image.freelog.com/avatar/${i.userId}`,
            isChoice: i.operationType === 5,
            collection: (i.subjectType === 4 && !!resourceVersionInfo)
              ? {
                status: i.serializeStatus === 1 ? 'finish' : 'unFinish',
                count: resourceVersionInfo.catalogueProperty.collection_item_count,
              }
              : null,
          };
        }),
    ];

    // console.log()
    const { state, more } = listStateAndListMore({
      list_Length: list.length,
      total_Length: data_resources.totalItem,
      // has_FilterCriteria: search !== '' || get$selectedOperationCategoryIDs().at(0) !== '#all',
      has_FilterCriteria: search !== '' || get$selectedOperationCategoryIDs()[0] !== '#all',
    });

    set$search(search);
    set$dataSource(list);
    set$state(state);
    // set$state('noData');
    set$more(more);
    set$totalItem(data_resources.totalItem);
  }

  // if ($state === 'loading') {
  //   return (<div style={{
  //     width: 1540,
  //     // display: 'flex',
  //     // alignItems
  //   }}>
  //     <FLoadingTip height={600} />
  //   </div>);
  // }

  // if ($state === 'noData') {
  //   return <FNoDataTip height={600} tipText={'无数据'} />;
  // }

  return (<>


    {
      $state === 'noData' && (<FNoDataTip height={600} tipText={'无数据'} />)
    }

    <div
      className={styles.styles}
      style={{
        display: $state !== 'noData' ? 'flex' : 'none',
      }}
    >
      <div style={{ height: 30 }} />
      {
        $search !== '' && (<>
          {
            $totalItem !== -1 && (<div className={styles.total}>
              <FComponentsLib.FContentText
                type={'normal'}
                text={`以下是${$search}相关的结果（${$totalItem}）`}
                style={{
                  color: '#999',
                }}
              />
            </div>)
          }

          <div style={{ height: 45 }} />
        </>)
      }

      <FOperationCategoryFilter
        value={$selectedOperationCategoryIDs}
        onChange={(value) => {
          // console.log(value);
          // dispatch<OnChange_SelectedOperationCategoryIDs_Action>({
          //   type: 'discoverPage/onChange_SelectedOperationCategoryIDs',
          //   payload: {
          //     value: value,
          //   },
          // });
          set$selectedOperationCategoryIDs(value);
          handle(true);
        }}
      />

      {
        $state === 'loading' && (<div style={{
          width: 1540,
          // display: 'flex',
          // alignItems
        }}>
          <FLoadingTip height={600} />
        </div>)
      }

      {
        $state === 'noSearchResult' && (<FNoDataTip
          height={600}
          // tipText={`抱歉，没有找到与${$search}相关的结果`}
          tipText={FI18n.i18nNext.t('msg_search_no_resault_found', {
            SearchKeyWords: $search,
          })}
        />)
      }

      {
        $state === 'loaded' && (<>
          <div style={{ height: 10 }} />
          <div className={styles.Content}>
            {
              $dataSource.map((resource, j) => (
                <FResourceCard
                  key={resource.id}
                  resource={resource}
                  // className={styles.FResourceCard}
                  onClick={() => {
                    if (resource.collection) {
                      window.open(FUtil.LinkTo.collectionDetails({
                        collectionID: resource.id,
                      }));
                    } else {
                      window.open(
                        FUtil.LinkTo.resourceDetails({
                          resourceID: resource.id,
                        }),
                      );
                    }

                  }}
                  // collection={{
                  //   status: j % 2 === 0 ? 'finish' : 'unFinish',
                  //   count: j,
                  // }}
                />
              ))
            }
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
          </div>

          <div style={{ height: 100 }} />

          <FListFooter
            state={$more}
            onClickLoadMore={() => {
              handle(false);
            }}
          />

          {/*{$totalItem > $dataSource.length && (*/}
          {/*  <>*/}
          {/*    <div style={{ height: 100 }} />*/}
          {/*    <div className={styles.bottom}>*/}
          {/*      <Button*/}
          {/*        className={styles.loadMore}*/}
          {/*        onClick={() => {*/}
          {/*          // dispatch<OnClickLoadMoreBtnAction>({*/}
          {/*          //   type: 'discoverPage/onClickLoadMoreBtn',*/}
          {/*          // });*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        加载更多*/}
          {/*      </Button>*/}
          {/*    </div>*/}
          {/*  </>*/}
          {/*)}*/}
          <div style={{ height: 100 }} />
        </>)
      }

      {/*{*/}
      {/*  $totalItem === 0 && (<FNoDataTip height={'calc(100vh - 275px - 52px)'} tipText={'没有符合条件的资源'} />)*/}
      {/*}*/}

    </div>
  </>);
}

export default Resource;
